import { render, staticRenderFns } from "./DetailIntroducingBroker.vue?vue&type=template&id=014f58df&scoped=true&"
import script from "./DetailIntroducingBroker.vue?vue&type=script&lang=js&"
export * from "./DetailIntroducingBroker.vue?vue&type=script&lang=js&"
import style0 from "./DetailIntroducingBroker.vue?vue&type=style&index=0&id=014f58df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014f58df",
  null
  
)

export default component.exports